
export default {
    name: 'motif-histoire',
    components: {},
    props: ['consultation', 'is_printable'],
    data() {
        return {

        }
    },
    computed: {
        consultation_motif_historique() {
            return this.$store.getters["consultation_motif_historique"];
        },
    },

    async mounted() {
        await this.$store.dispatch("getConsultationMotifs", 
            { consultation_id: this.consultation.id, est_en_cours: false }
        ).then(() => {
            console.log("Motif en Historique: ", this.consultation_motif_historique)
            this.motif_is_loading = false
        })
    },

    methods: {

    }
}


